import CachedIcon from "@mui/icons-material/Cached";
import CropOutlinedIcon from "@mui/icons-material/CropOutlined";
import { Box, Grid, Paper } from "@mui/material";
import { formThumbnailFromGCBURL } from "@platformx/x-image-render";
import { useStyles } from "./ImageOnHover.styles";

export const ImageOnHoverCard = ({
  onUploadClick,
  setIsClickedPublish,
  setOnHover,
  originalImage,
  onCropClick,
}) => {
  const classes = useStyles();

  const thumbnailUrl = originalImage?.original_image_relative_path
    ? formThumbnailFromGCBURL(
        originalImage?.original_image_relative_path,
        originalImage?.ext,
        "quality=85,format=webp",
      )
    : "";

  return (
    <Grid container>
      <Grid item xs={12} md={9} lg={5}>
        <Box
          className={classes.onHoverImage}
          onMouseEnter={() => setOnHover(true)}
          onMouseLeave={() => setOnHover(false)}>
          <Paper
            sx={{
              height: "inherit",
            }}>
            <img
              src={thumbnailUrl}
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
              alt='img'
            />
          </Paper>
          <Box
            sx={{
              position: "absolute",
              top: "0",
              width: "100%",
              height: "inherit",
              display: "flex",
              alignItems: "right",
              justifyContent: "right",
              borderRadius: "5px",
            }}>
            <Box
              sx={{
                display: "flex",
                position: "relative",
                flexDirection: "column",
              }}>
              <Box
                sx={{ cursor: "pointer" }}
                onClick={() => {
                  setIsClickedPublish(false);
                  onUploadClick("Images", "replace");
                }}
                data-testid='image-replace'>
                <Box
                  sx={{
                    borderRadius: "3px",
                    backgroundColor: "#fff",
                    width: "25px",
                    height: "25px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "absolute",
                    bottom: "50px",
                    right: "14px",
                  }}>
                  <CachedIcon sx={{ fontSize: "20px" }} />
                </Box>
              </Box>
              <Box
                sx={{ cursor: "pointer" }}
                onClick={(e) => {
                  e.stopPropagation();
                  onCropClick();
                }}
                data-testid='article-image-crop-handle'>
                <Box
                  sx={{
                    borderRadius: "3px",
                    backgroundColor: "#fff",
                    width: "25px",
                    height: "25px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "absolute",
                    bottom: "14px",
                    right: "14px",
                  }}>
                  <CropOutlinedIcon sx={{ fontSize: "20px" }} />
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};
